module.exports = __webpack_public_path__ + "static/media/favicon.d41d8cd9.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/favicon.ico
// module id = 839
// module chunks = 0